export default __webpack_public_path__ + "static/media/au-tas.e5851b30.svg";